const server = process.env.REACT_APP_SERVER_URL || "";

export const sliderApi = {
  getSliders: async () => {
    const response = await fetch(`${server}/api/slider`);
    return response.json();
  },
  update: async (data: any, id: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (key === "oldImages") {
          formData.append(key, JSON.stringify(data[key]));
        } else if (key === "newImages") {
          for (let i = 0; i < data[key].length; i++) {
            formData.append("newImages", data[key][i]);
          }
        } else {
          formData.append(key, data[key]);
        }
      }
    }
    const result = await fetch(`${server}/api/slider/${id}`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
      },
      body: formData,
    });
    return result.json();
  },
  add: async (formData: any) => {
    try {
      const form = new FormData();
      if (formData.images) {
        for (let i = 0; i < formData.images.length; i++) {
          form.append("images", formData.images[i]);
        }
      }
      const response = await fetch(`${server}/api/slider`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token") ?? ""}`,
        },
        body: form,
      });
      if (response.ok) {
        const data = await response.json();

        return data;
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  },
};
